import { LegacyPhotosUnlinkedFromAssetEventV2 } from '../event/legacy-photos-unlinked-from-asset-v2.event';
const legacyPhotosUnlinkedFromAssetV2Projections = {
    [LegacyPhotosUnlinkedFromAssetEventV2.name]: (_event, state) => ({
        ...state,
    }),
};
export default legacyPhotosUnlinkedFromAssetV2Projections;
//# sourceMappingURL=legacy-photos-unlinked-from-asset-v2.projection.js.map